import { render, staticRenderFns } from "./page1.vue?vue&type=template&id=dbde6302&scoped=true"
import script from "./page1.vue?vue&type=script&lang=js"
export * from "./page1.vue?vue&type=script&lang=js"
import style0 from "./page1.vue?vue&type=style&index=0&id=dbde6302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbde6302",
  null
  
)

export default component.exports